import { Container, Row } from "react-bootstrap";
import "./Filler-area.css";

const Filler = () => {
  return (
    <section className="filler" id="filler">
      <Container>
        <Row className="align-items-center"></Row>
      </Container>
    </section>
  );
};

export default Filler;
